export default "__VITE_ASSET__3d282b9f__"